module.exports = __webpack_public_path__ + "files/9e9563a843b64fb5758c5a6d084e2658.svg";